import { useRef } from 'react';
import { palette2, RcClasses } from '../../../../foundation';
export var RcStepIconClasses = RcClasses(['root', 'active', 'text'], 'RcStepIcon');
export var iconColor = palette2('interactive', 'b02');
export var iconTextColor = palette2('neutral', 'f01');
/**
 * check is that editable state, if that have complete twice and is active, that will be true
 * because when user complete step first that should keep complete state,
 * only when user go back to that step that will be edit
 * @param props prop of `RcStepIconProps`
 */
export var useIsEditable = function (_a) {
    var active = _a.active, completed = _a.completed;
    var completedTimesRef = useRef(0);
    var isEditRef = useRef(false);
    var completedTimes = completedTimesRef.current;
    var isEdit = isEditRef.current;
    if (completedTimes === 0 && !active && completed) {
        completedTimesRef.current = 1;
    }
    else if (completedTimes === 1 && !completed) {
        completedTimesRef.current = 0;
    }
    if (completedTimes === 1) {
        if (!isEdit && active) {
            isEditRef.current = true;
        }
        else if (isEdit && !active) {
            isEditRef.current = false;
        }
    }
    return isEditRef.current;
};
